/**
 * nav.js — helpers for pages that live at their own URL (/accounts/invoices/…,
 * /accounts/vat). The app uses react-router's BrowserRouter (index.js), so
 * navigation must go through the router — a raw pushState is not seen by
 * useLocation() and the page would not change (the 0.9.0.46 defect).
 */
import { useLocation, useNavigate } from 'react-router-dom';

/** Which Dashboard page a path belongs to (null = the main grid). */
export function pageForPath(pathname) {
  if (pathname.startsWith('/accounts/invoices')) return 'invoiceIntake';
  if (pathname.startsWith('/accounts/vat')) return 'vat';
  return null;
}

/** useNav() → { path, navigate } bound to the router. */
export function useNav() {
  const location = useLocation();
  const navigate = useNavigate();
  return { path: location.pathname + location.search, pathname: location.pathname, search: location.search, navigate: (to, opts) => navigate(to, opts) };
}
